<template>
  <section>
    <mdb-card :class="addClass" :key="comment.id">
      <mdb-card-header class="text-left">
        <div class="subject text-left" v-if="comment.subject && type != 'conversation'">{{ comment.subject }}</div>
        <div>
          <avatar :avatar="comment.authorPhoto" :memberId="comment.memberId" :reputation="comment.reputationRibbon"
                  :size="45"/>
          <span class="text-black-50">{{ comment.author }}
            <mdb-icon icon="clock"/>
            {{ agoText }}
          </span>
          <div v-if="type=='forum' && !isReply">
            <mdb-btn @click="followComment(comment)" icon="eye" rounded size="sm" v-if="!comment.following">Follow
              Topic
            </mdb-btn>
            <mdb-btn @click="unfollowComment(comment)" icon="eye-slash" rounded size="sm" v-if="comment.following">Stop
              Following
            </mdb-btn>
          </div>
        </div>

      </mdb-card-header>
      <mdb-card-body class="text-left">
        <div :id="'message-'+comment.id" v-html="comment.messageText"/>
        <div class="likes-container">
          <a @click.prevent="showLikes" href="" v-for="like in comment.likeDistribution">
            <span class="comment-icon badge badge-pill badge-primary mr-2">{{ like.emoji }} {{like.count}} </span>
          </a>
        </div>
      </mdb-card-body>
      <mdb-card-footer class="text-left" v-if="comment.hasOwnProperty('attachments') && comment.attachments.length > 0">
        <mdb-row>
          <mdb-col class="mb-4 col-lg-3 col-md-4 col-sm-12" v-for="a in comment.attachments" :key="a.id">
            <div>
              <a @click.prevent="viewImage(a.url)">
                <img :src="a.thumb"/>
              </a>
            </div>
            <div>
              <mdb-tooltip :options="{placement: 'top'}" material trigger="hover" v-if="comment.allowEdit">
                <span slot="tip">Delete Image</span>
                <a @click.prevent="deleteImage(a)" href="" slot="reference">
                  <i class="fas fa-trash"></i>
                </a>
              </mdb-tooltip>
              <mdb-tooltip :options="{placement: 'top'}" material trigger="hover">
                <span slot="tip">Open in New Window</span>
                <a :href="a.url" slot="reference" target="_blank">
                  <i class="fas fa-external-link"></i>
                </a>
              </mdb-tooltip>

            </div>
          </mdb-col>
        </mdb-row>
      </mdb-card-footer>
      <mdb-card-footer>
        <span class="message-tools">
          <mdb-tooltip :options="{placement: 'top'}" material trigger="hover" v-if="allowReply && !readOnly">
            <span slot="tip">{{ $tc("common.messaging.reply", 1) }}</span>
            <a @click.prevent="reply" class="pull-right" href="" slot="reference">
              <mdb-icon icon="reply"/>
            </a>
          </mdb-tooltip>
          <mdb-tooltip :options="{placement: 'top'}" material trigger="hover" v-if="comment.allowDelete">
            <span slot="tip">{{ $t("common.button.delete") }}</span>
            <a @click.prevent="deletePending = true" href="" slot="reference">
              <i class="fas fa-trash"></i>
            </a>
          </mdb-tooltip>
          <mdb-tooltip :options="{placement: 'top'}" material trigger="hover" v-if="comment.allowEdit && !readOnly">
            <span slot="tip">{{ $t("common.button.edit") }}</span>
            <a @click.prevent="editMessage" href="" slot="reference">
              <i class="fas fa-pencil"></i>
            </a>
          </mdb-tooltip>
          <span v-if="!comment.userLikes && !readOnly">
            <a @click.prevent="showPickerModal = true" href="" slot="reference">
              <i class="fal fa-face-smile-plus"></i>
            </a>
          </span>

          <mdb-tooltip :options="{placement: 'top'}" material trigger="hover" v-if="comment.userLikes && !readOnly">
            <span slot="tip">{{ $t("common.button.unlike") }}</span>
            <a slot="reference" @click.prevent="unlike" href="">
              <i class="fas fa-smile"></i>
            </a>
          </mdb-tooltip>
        </span>
        <mdb-btn @click="showReplies=false" icon="eye-slash" rounded size="sm"
                 v-if="showReplies && comment.totalReplies > 0">{{ $t("common.messaging.hideReplies") }}
        </mdb-btn>
        <span v-if="comment.totalReplies > 0 && !showReplies">
          <mdb-btn @click="showReplies=true" icon="eye" rounded size="sm">
            {{ $t("common.button.show") }} {{ comment.totalReplies }}
            {{ $tc("common.messaging.reply", comment.totalReplies) }}
          </mdb-btn>
        </span>

      </mdb-card-footer>
      <div class="replies-container" v-if="comment.totalReplies > 0 && showReplies">
        <message-content :comment="reply" :highlight="childHighlight" :id="id" :isReply="true" :key="reply.id"
                         :type="type"
                         :readOnly="readOnly"
                         :labels="labels"
                         @deleted="replyDeleted(reply)"
                         v-for="reply in comment.replies"
        />
        <mdb-btn :disabled="loading" @click="loadMore" icon="chevron-circle-down" rounded
                 size="sm"
                 v-if="comment.nextReplyOffset!=0">{{ $t("common.button.loadMore") }}
        </mdb-btn>
      </div>

      <yes-no-modal @no="deletePending = false"
                    @yes="deleteConfirmed"
                    question="Are you sure you wish to remove this message?" v-if="deletePending"/>

      <yes-no-modal @no="deleteImagePending = false"
                    @yes="deleteImageConfirmed"
                    question="Are you sure you wish to remove this image?" v-if="deleteImagePending"/>

      <mdb-modal :show="showPickerModal" @close="showPickerModal = false" size="sm">
        <mdb-modal-body>
      <div class="icon-picker-modal" style="position:relative;" v-click-outside="clickOutside" v-if="showPickerModal">
        <button v-for="i in iconsToShow" @click="like(i)">{{ iconEmojis[i] }}</button>
      </div>
        </mdb-modal-body>
      </mdb-modal>

      <mdb-modal :show="showLikesModal" @close="showLikesModal = false" scrollable size="lg">
        <mdb-modal-header :close="true" class="primary-color text-center text-white">
          <h5>Reactions</h5>
        </mdb-modal-header>
        <mdb-modal-body>
          <mdb-masonry :maxHeight="1000" :numCols="4">
            <span v-for="m in likes">
              <avatar :avatar="m.profile" :size="50" container-class=""/>
              {{ m.name }} <span class="user-reaction-emoji">{{m.emoji}}</span>
            </span>
          </mdb-masonry>
        </mdb-modal-body>
      </mdb-modal>
      <mdb-modal :show="imageModal" @close="imageModal = false" scrollable size="lg">
        <mdb-modal-header :close="true" class="primary-color text-center text-white">

        </mdb-modal-header>
        <mdb-modal-body>
          <a :href="imageUrl" target="_blank" @click="imageModal=false">
            <img :src="imageUrl" style="max-height:100%; max-width: 100%;"/>
          </a>
        </mdb-modal-body>
      </mdb-modal>

      <message-create @cancel="addDialog=false" @save="postReply"
                      :label="$t('common.messaging.writeNew') + ' ' +  labels.type + '...'"
                      :button-label="labels.buttonLabel"
                      v-if="addDialog"/>
      <message-create :originalSubject="comment.subject"
                      :originalText="comment.messageText"
                      :requireSubject="type=='forum' && !isReply"
                      @cancel="editDialog=false"
                      @save="postCommentEdit"
                      :label="$t('common.button.edit') + ' ' + labels.type + ' ...'"
                      :button-label="labels.buttonLabel"
                      v-if="editDialog"
      />

    </mdb-card>

    <mdb-modal :show="attachmentModal " size="lg" @close="attachmentModal=false">
      <mdb-modal-header :close="true">

      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-file-input v-on:getValue="uploadFile"/>
      </mdb-modal-body>
    </mdb-modal>

  </section>
</template>
<script>
import avatar from "./Avatar";
import api from "../../services/groupsPlaceApi";
import yesNoModal from "../common/YesNoModal"
import messageCreate from "./MessageCreate";
import userContent from "./UserContent";
import Vue from "vue";

import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbFileInput,
  mdbIcon,
  mdbMasonry,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTooltip
} from 'mdbvue';

export default {
  name: 'messageContent',
  components: {
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbChip,
    mdbMasonry,
    mdbRow,
    mdbCol,
    mdbTooltip,
    mdbFileInput,
    avatar,
    yesNoModal,
    messageCreate,
    userContent
  },
  props: {
    type: {
      type: String,
      default: null
    },
    id: {
      type: Number,
      default: null
    },
    comment: {
      type: Object,
      default: null
    },
    allowReply: {
      type: Boolean,
      default: false
    },
    isReply: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: String,
      default: null
    },
    allowAttach: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      default: function () {
        return {type: "Reply", pluralType: "Replies", buttonLabel: "Reply"}
      }
    },
  },
  computed: {
    agoText: function () {
      let ago = this.comment.ago
      if (ago.days == 0 && ago.hours == 0 && ago.minutes == 0) return "Just now";
      if (ago.days == 0 && ago.hours == 0 && ago.minutes != 0) return "" + ago.minutes + "m";
      if (ago.days == 0 && ago.hours != 0) return "" + ago.hours + "h";
      return "" + ago.days + "d";
    }
  },
  data() {
    return {
      showReplies: false,
      deletePending: false,
      deleteImagePending: false,
      pendingImage: null,
      imageUrl: null,
      imageModal: false,
      showLikesModal: false,
      attachmentModal: false,
      likes: [],
      addDialog: false,
      loading: false,
      editDialog: false,
      addClass: "mt-2",
      childHighlight: null,
      showPickerModal: false,
      iconEmojis: {
        'like': '👍',
        'love': '❤️',
        'sad': '😢',
        'wow': '😮',
        'laugh': '😂',
        'fire': '🔥',
        'angry': '😡'
      },
      iconsToShow: [
        'like', 'love', 'sad', 'wow', 'laugh', 'fire', 'angry'
      ],
      urlRegex: /(\b(^https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
    }
  },
  mounted() {
    if (this.type == "forum") this.showReplies = true
    if (this.highlight) {
      this.showReplies = true
      if (this.comment.id == this.highlight) {
        this.addClass = "highlighted yellow lighten-4 d-block d-md-flex mb-4"
        Vue.nextTick().then(function () {
          let elements = document.getElementsByClassName("highlighted")
          if (elements && elements.length > 0) {
            elements[0].scrollIntoView()
          }
        })
      } else {
        this.childHighlight = this.highlight
      }
    }
    if (!this.showReplies && this.comment.replies && this.comment.replies.length <= 2) this.showReplies = true
    this.fixContent()
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) {
            warn += `Found in component '${compName}'`
          }
          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        setTimeout(() => {
          document.addEventListener('click', handler)
        }, 100)   //don't treat original click as outside the modal

      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  },
  methods: {
    renderIconPickModal(selector) {

    },
    viewImage(url) {
      this.imageUrl = url
      this.imageModal = true
    },
    reply() {
      this.addDialog = true
    },
    editMessage() {
      this.editDialog = true
    },
    uploadFile: async function (file) {
      this.attachmentModal = false
      let toUpload = file[0]
      await this.$store.dispatch("setExecuting", true)
      const reduce = require('image-blob-reduce')();
      if (file[0].size >= 2000000) {
        await reduce.toBlob(file[0], {max: 2000})
          .then(blob => {
            toUpload = blob
          })
      }
      api.postImage("/message/image/" + this.comment.id, toUpload).then(
        (results) => {
          this.comment.attachments.push(results.data)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    postReply(msg) {
      this.addDialog = false
      this.$store.dispatch("setExecuting", true)
      let url = "/message/reply/" + this.comment.id
      api.post(url, {messageText: msg.text, postAsAdmin: msg.postAsAdmin, pastedImages: msg.pastedImages}).then(
        (results) => {
          if (this.order == "asc") this.comment.replies.push(results.data.message)
          else this.comment.replies.unshift(results.data.message)
          this.comment.totalReplies++
        },
        (error) => {
          this.$notify.error({message: "Could not post comment. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    clickOutside() {
      this.showPickerModal = false
    },
    postCommentEdit(msg) {
      this.editDialog = false
      this.$store.dispatch("setExecuting", true)
      let url = "/message/edit/" + this.comment.id
      api.post(url, {
        messageText: msg.text, subject: msg.subject,
        postAsAdmin: msg.postAsAdmin, pastedImages: msg.pastedImages
      }).then(
        (results) => {
          this.comment.messageText = results.data.comment.messageText
          this.comment.subject = results.data.comment.subject
        },
        (error) => {
          this.$notify.error({message: "Could not post comment. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteImage(img) {
      this.pendingImage = img
      this.deleteImagePending = true
    },

    deleteImageConfirmed() {
      this.deleteImagePending = false
      this.$store.dispatch("setExecuting", true)
      let url = "/image/messageImageDelete/" + this.pendingImage.id
      api.delete(url).then(
        (results) => {
          let loc = this.comment.attachments.indexOf(this.pendingImage)
          if (loc > -1) this.comment.attachments.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({message: "Could not delete comment. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    deleteConfirmed() {
      this.$store.dispatch("setExecuting", true)
      let url = "/message/delete/" + this.comment.id
      api.delete(url).then(
        (results) => {
          this.$emit("deleted", this.comment)
        },
        (error) => {
          this.$notify.error({message: "Could not delete comment. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    like(type) {
      this.showPickerModal = false
      let url = "/message/like/" + this.comment.id
      api.post(url, {type: type}).then(
        (results) => {
          this.comment.likeDistribution = results.data.likeDistribution
          this.comment.userLikes = true
        },
        (error) => {
          this.$notify.error({message: "Could not like comment. " + error.response.data, timeOut: 20000})
        })
    },
    unlike() {

      let url = "/message/unlike/" + this.comment.id
      api.get(url).then(
        (results) => {
          this.comment.likeDistribution = results.data.likeDistribution
          this.comment.userLikes = false
        },
        (error) => {
          this.$notify.error({message: "Could not un-like comment. " + error.response.data, timeOut: 20000})
        })
    },
    showLikes() {
      this.$store.dispatch("setExecuting", true)
      let url = "/message/likes/" + this.comment.id
      api.get(url).then(
        (results) => {
          this.likes = results.data.likes
          this.showLikesModal = true
        },
        (error) => {
          this.$notify.error({message: "Could not get likes. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    loadMore() {
      this.loading = true
      let url = "/message/getReplies/" + this.comment.id + "?offset=" + this.comment.nextReplyOffset
      api.get(url).then(
        (results) => {
          this.comment.replies.push.apply(this.comment.replies, results.data.replies)
          this.comment.totalReplies = results.data.totalReplies
          this.comment.nextReplyOffset = results.data.nextReplyOffset
        },
        (error) => {
          if (error.response.status != 401) this.$notify.error({
                                                                 message: "Could not load comments. " + error.response.data,
                                                                 timeOut: 20000
                                                               })
        }).then(() => {
        this.loading = false
      })
    },
    replyDeleted(reply) {
      this.$emit("replyDeleted", this.comment, reply)
    },
    fixContent() {
      this.$nextTick(function () { /*Need to wait for content to get rendered!*/
        let doc = document.getElementById("message-" + this.comment.id)
        let elements = doc.getElementsByTagName("img")
        for (let el of elements) {
          el.setAttribute("style", "max-width: 75%; height: unset; margin-left: auto; margin-right: auto; display: block;")
        }
      })
    },
    followComment(c) {
      this.$store.dispatch("setExecuting", true)
      let url = "/message/follow/" + c.id
      api.post(url, {}).then(
        (results) => {
          c.following = true
        },
        (error) => {
          this.$notify.error({message: "Could not follow topic. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    unfollowComment(c) {
      this.$store.dispatch("setExecuting", true)
      let url = "/message/unfollow/" + c.id
      api.post(url, {}).then(
        (results) => {
          c.following = false
        },
        (error) => {
          this.$notify.error({message: "Could not unfollow topic. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};
</script>
<style scoped>
.message-tools {
  font-size: 1.45em;
}

.message-tools a {
  padding-right: 15px;
}

.subject {
  text-transform: uppercase;
  fill: rgba(0, 0, 0, .54);
  font-size: 1.25em;
  font-weight: 600;
}

.comment-avatar {
  padding-bottom: 10px;
}

.replies-container {
  padding-left: 15%;
}

.icon-picker-modal {
  border-radius: 0.75rem; /* rounded-xl */
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); /* shadow-2xl */
  padding: 0.75rem; /* p-3 */
  border: 1px solid #e5e7eb; /* border border-gray-200 */
  gap: 0.75rem; /* space-x-3 */
  align-items: center;
  justify-content: center;


}



/* Individual icon button styling within the modal */
.icon-picker-modal button {
  padding: 0.5rem; /* p-2 */
  border-radius: 9999px; /* rounded-full */
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out, transform 0.2s ease-in-out;
  outline: none; /* focus:outline-none */
  font-size: 1.5rem; /* text-xl for emoji */
  line-height: 1; /* Adjust line height for emoji */
}

.icon-picker-modal button:hover {
  background-color: #f3f4f6; /* hover:bg-gray-100 */
  transform: scale(1.1); /* hover:scale-110 */
}

.icon-picker-modal button:focus {
  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.75), 0 0 0 4px rgba(96, 165, 250, 0.5); /* focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 */
}

/* Selected icon color */
.icon-picker-modal button.selected-icon {
  color: #2563eb; /* text-blue-600 */
}

.icon-picker-modal button:not(.selected-icon) {
  color: #4b5563; /* text-gray-600 */
}

.user-reaction-emoji {
  font-size: 1.5em;
}


</style>
